import { defineStore } from 'pinia';
var useAlertStoreDefinition = defineStore('alert', {
  state: function state() {
    return {
      title: '',
      content: '',
      type: 'success',
      timeout: 5000
    };
  },
  actions: {
    showMessage: function showMessage(payload) {
      this.title = payload.title;
      this.content = payload.content;
      this.type = payload.type;
      this.timeout = payload.timeout;
    }
  },
  persist: true
});

// VUE 2.7 WORKAROUND — see composables/usePinia.ts. Remove this wrapper at
// the Vue 3 flip and export useAlertStoreDefinition directly as
// useAlertStore instead.
export function useAlertStore() {
  return useAlertStoreDefinition(usePinia());
}